import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';

import { Role } from '@shared/models/enums';
import { AuthenticationService } from './authentication.service';
import { LoggedUserModel } from './logged-user.model';

/** The one place the admin app decides "SuperAdmin" — the menu, the guard and pages ask here. */
export function isSuperAdmin(user: LoggedUserModel | null | undefined): boolean {
  return user?.primaryRole === Role.SuperAdmin;
}

/**
 * Only a SuperAdmin; anyone else goes to the unauthorized page. The API enforces the same rule where
 * it matters (`[RequireSuperAdmin]`), so this only spares other admins a page they cannot use.
 */
export const superAdminGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(AuthenticationService)
    .getLoggedUser()
    .pipe(
      filter((user) => user != null),
      take(1),
      map((user) => isSuperAdmin(user) || router.createUrlTree(['authentication/unauthorized'])),
    );
};
